/** Measured line-break agreement with InDesign, read from the harness report at build time. */
export interface Agreement { rate: number; cases: number }

/** Composed accepted edits stand in for the artwork until the designer republishes: say so. */
const ACCEPTED = 'Accepted edits are shown composed in the browser until the designer republishes from InDesign.';

/**
 * The viewer is a rendering, not the artwork, and nothing on screen said so. The mark quotes the
 * harness figure when there is one so the caveat is a measurement rather than a disclaimer.
 */
export function previewLabel(agreement: Agreement | null): { short: string; title: string } {
  if (!agreement) {
    return {
      short: 'Browser preview',
      title: `This is a browser rendering, not the artwork. Fonts, colour, images and line breaks are approximate. ${ACCEPTED}`,
    };
  }
  const pct = (agreement.rate * 100).toFixed(1);
  const cases = agreement.cases.toLocaleString('en-GB');
  return {
    short: `Browser preview · ${pct}% match`,
    title: `This is a browser rendering, not the artwork. Line breaks matched InDesign on ${pct}% of ${cases} measured cases; fonts, colour and images are approximate. The PDF preview carries the same caveat. ${ACCEPTED}`,
  };
}
